import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

// 查询待办列表
export const getTodoList = async params => {
  return request(`${UrlConfig.WorkOrder.GetTodoList}`, {
    method: METHODS.GET,
    params,
  })
}
// 查询我关注的流程待办
export const getFollowAppList =async() => {
  return request(`${UrlConfig.WorkOrder.GetFollowAppList}`, {
    method: METHODS.GET,
  })
}

// 查询我关注的流程列表
export const getFollowList =async(data) => {
  return request(`${UrlConfig.WorkOrder.GetFollowList}`, {
    method: METHODS.POST,
    data
  })
}

// 查询待办详情
export const getTodoItem = async data => {
  return request(`${UrlConfig.WorkOrder.GetTodoItem}`, {
    method: METHODS.POST,
    data,
  })
}

// 查询待办数量
export const getTodoCount = async () => {
  return request(`${UrlConfig.WorkOrder.GetTodoCount}`, {
    method: METHODS.GET,
  })
}

// 获取跳转URL
export const getJumpUrl = id => {
  return request(`${UrlConfig.WorkOrder.GetJumpUrl}/${id}`, {
    method: METHODS.GET,
  })
}
// 根据ID查询单条工单
export const getWorkOrder = id => {
  return request(UrlConfig.WorkOrder.GetWorkOrder.replace('{id}', id), {
    method: METHODS.GET,
  })
}
